import { useCallback } from 'react'
import { useIntl } from 'react-intl'

import { sendClickAnaliticsEvent } from 'Analitics'
import { SearchIcon, CrossIcon } from 'Icons'

type SearchProps = {
  value: string
  onChange: (value: string) => void
}

export default function Search({ value, onChange }: SearchProps) {
  const intl = useIntl()
  const searchPlaceholder = intl.formatMessage({ id: 'input.search', defaultMessage: 'Search' })

  const onResetButtonClick = useCallback(() => {
    sendClickAnaliticsEvent('search-reset-button')
    onChange('')
  }, [onChange])

  return (
    <label className="input input-sm bg-base-200 max-w-60 font-sans">
      <SearchIcon />
      <input
        placeholder={searchPlaceholder}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <button
        className="cursor-pointer opacity-50 transition-opacity enabled:hover:opacity-100"
        disabled={!value}
        onClick={onResetButtonClick}
      >
        <CrossIcon />
      </button>
    </label>
  )
}
